import StudiesApi from "@/api/studies";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
const errorHandler = (err) => {
    console.error(err);
};
export const useStudiesStore = defineStore("studies", () => {
    const studies = ref([]);
    const studiesMap = computed(() => new Map(studies.value.map((s) => [s.studyId, s])));
    const pending = ref(false);
    const getStoredStudyIndex = (study) => studies.value.findIndex((s) => s.studyId === study.studyId);
    const getStoredStudyById = (studyId) => studies.value.find((s) => s.studyId === studyId);
    const storeStudy = (study) => {
        const index = getStoredStudyIndex(study);
        if (index !== -1) {
            studies.value.splice(index, 1, study);
        }
        else {
            studies.value = [...studies.value, study];
        }
    };
    const load = async () => {
        console.error("Study data could not be loaded from page.");
        return Promise.resolve([]);
    };
    const onLoad = (studies) => studies.map(storeStudy);
    const getStudies = async () => {
        pending.value = true;
        try {
            const res = await StudiesApi.getStudies();
            if (!res)
                return;
            res.map(storeStudy);
        }
        catch (err) {
            errorHandler(err);
        }
        finally {
            pending.value = false;
        }
    };
    return {
        studies,
        studiesMap,
        pending,
        load,
        onLoad,
        getStudies,
        getStoredStudyById
    };
}, {
    loadable: {
        action: "load",
        reloadable: true,
        fromPage: {
            key: "/studies",
            onLoad: "onLoad"
        }
    }
});
